// TOP LEVEL IMPORTS
import React from 'react';
// COMPONENTS
import TopArea from './TopArea';
import ContractsTable from './ContractsTable';
import SectionRow from 'components/common/SectionRow';

export class ClientContracts extends React.Component {
  render() {
    return (
      <SectionRow>
        <TopArea clientId={this.props.clientId} />
        <ContractsTable contracts={this.props.client.contracts} windowWidth={this.props.windowWidth} />
      </SectionRow>
    );
  }
}

export default ClientContracts;



// WEBPACK FOOTER //
// ./src/routes/app-client-detail/ClientContracts/index.js